export const processSteps = [
  {
    step: "Step 01",
    title: "Initial consultation",
    description:
      "A focused conversation to understand your situation, your priorities and what a good outcome looks like.",
  },
  {
    step: "Step 02",
    title: "Track every stage",
    description: "Clear updates at each milestone, so you always know what comes next.",
  },
  {
    step: "Step 03",
    title: "Transparent scope & fees",
    description: "A tailored plan and upfront pricing built around your matter.",
  },
  {
    step: "Step 04",
    title: "We see it through",
    description:
      "From first advice to final resolution, the same team stays with your matter until it’s settled.",
  },
];

export const matterStages = [
  { label: "Enquiry reviewed", state: "done" },
  { label: "Documents assessed", state: "done" },
  { label: "Advice & strategy", state: "current" },
  { label: "Resolution", state: "upcoming" },
] as const;

export const completionChecklist = ["Agreement reviewed", "Risks explained", "Next steps agreed"];
